import { useEffect, useState } from "preact/hooks";
import { contentConsoleUrl, fetchAlias, fetchFeatures } from "../../api/contentClient";
import type { Environment } from "../../types";

export function FeaturesDisplay({ environment, solution }: { environment: Environment; solution: string }) {
  const [features, setFeatures] = useState<string[] | null>(null);

  useEffect(() => {
    let cancelled = false;
    fetchAlias(environment, solution)
      .then((alias) => (cancelled ? null : fetchFeatures(environment, alias)))
      .then((data) => { if (!cancelled && data) setFeatures(data.features); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [environment, solution]);

  if (!features || features.length === 0) return null;
  return (
    <ul class="features-list">
      {features.map((f) => <li key={f}>{f}</li>)}
    </ul>
  );
}

export function ContentCell({ environment, solution }: { environment: Environment; solution: string }) {
  const [alias, setAlias] = useState<string | null>(null);
  const [hasFeatures, setHasFeatures] = useState(false);

  useEffect(() => {
    let cancelled = false;
    fetchAlias(environment, solution)
      .then((resolvedAlias) => {
        if (cancelled) return null;
        setAlias(resolvedAlias);
        return fetchFeatures(environment, resolvedAlias);
      })
      .then((data) => {
        if (cancelled) return;
        setHasFeatures((data?.features?.length ?? 0) > 0);
      })
      .catch((err) => console.error("Error fetching content metadata:", err));
    return () => { cancelled = true; };
  }, [environment, solution]);

  if (!alias) return <span>...</span>;

  return (
    <span>
      {hasFeatures && <span class="content-triangle">▾</span>}
      <a href={contentConsoleUrl(environment, alias)} target="_blank" rel="noreferrer" onClick={(e) => e.stopPropagation()}>
        {alias}
      </a>
    </span>
  );
}
